import * as _ from "lodash";
import {UserLoginForm as Validator} from '../../utils/validators';

interface Action {
    payload: any,
    type: string,
    apiError: string,
    field: string,
    value?: any,
    validate: boolean
}

interface Form {
    valid: boolean,
    changed: boolean
    data: {
        [key: string]: {
            required: boolean,
            added: boolean,
            value: any,
            error: any,
            dirty: boolean
        },
    }
}

const initialState: Form = {
    valid: false,
    data: {
        email: {
            required: true,
            added: false,
            value: null,
            error: null,
            dirty: false
        },
        password: {
            required: true,
            added: false,
            value: null,
            error: null,
            dirty: false
        },
    },
    changed: false,
};

const baseState = _.cloneDeep(initialState);


const UserRegisterForm = (state = initialState, action: Action) => {
    switch (action.type) {
        case 'USER_LOGIN_FORM_ADD_CHANGE':
            return Validator({...state.data}, action);
        case 'RESET_LOGIN_FORM':
            return _.cloneDeep(baseState);
        default:
            return state;
    }
};

export default UserRegisterForm;
